import React, {Suspense, useState} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
// import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import {Provider, useDispatch, useSelector} from 'react-redux'
import { AuthHandle } from './routing/AuthHandle'
import {UserInfoData} from './modules/api/auth'
import {USER_VERIFIED} from '../actions'
import {RootState} from '../reducer/reducer'

type Props = {
  basename: string
}


const App: React.FC<Props> = ({basename}) => {

  return (
      <Suspense fallback={<LayoutSplashScreen />}>
        <BrowserRouter basename={basename}>
          <I18nProvider>
            <LayoutProvider>
              <AuthHandle />
              {/*<AuthInit>*/}
                    <Routes />
                {/*</AuthInit>*/}
            </LayoutProvider>
        </I18nProvider>
      </BrowserRouter>
    </Suspense>
  )
}

export {App}
